import { SVG } from '@sleepstation/components'
import { propToFill } from '@sleepstation/style-api-helpers'
import {
  BottomBorderSVG,
  HeaderBorderSVG,
} from '@sleepstation/svgs-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { css } from 'styled-components'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const transformForKind = (kind, edge) => {
  // Outset
  if (kind === `outset`) {
    return edge === `top` ? `-100%` : `100%`
  }
  // Inset
  return edge === `top` ? `0` : `0`
}

const offsetForKind = (kind, edge) => {
  // Outset
  if (kind === `outset`) {
    return edge === `top` ? `top: 0.78vw;` : `bottom: 0.78vw;`
  }
  // Inset
  return edge === `top` ? `top: -0.25vw;` : `bottom: -0.78vw;`
}

const getTranslationProps = ({ kind, edge }) => css`
  ${offsetForKind(kind, edge)}
  transform: translate(0, ${transformForKind(kind, edge)});
`

const getSvg = (kind, edge, isHeader) => {
  if (isHeader) {
    return HeaderBorderSVG
  }
  if (edge === `top`) {
    return kind === `outset` ? HeaderBorderSVG : BottomBorderSVG
  }
  return HeaderBorderSVG
}

const getDropshadowDirection = (kind, edge, isHeader) => {
  if (isHeader) {
    return `5px`
  }
  if (edge === `top`) {
    return kind === `outset` ? `-5px` : `5px`
  }
  return kind === `outset` ? `5px` : `-5px`
}

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  ${getTranslationProps}
  z-index: 3;

  /* offset side-edges to ensure overlap */
  margin-left: -1px;
  margin-right: -1px;

  svg {
    filter: drop-shadow(0 ${getDropshadowDirection} 5px rgba(0 0 0 / 2%));
  }

  svg path {
    ${propToFill(`color`)}
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Border = ({ kind, edge, color, isHeader }) => {
  const svg = getSvg(kind, edge, isHeader)
  return (
    <Layout kind={kind} edge={edge} color={color} isHeader={isHeader}>
      <SVG svg={svg} />
    </Layout>
  )
}

Border.propTypes = {
  kind: PropTypes.string,
  edge: PropTypes.string,
  color: PropTypes.string,
  isHeader: PropTypes.bool,
}

Border.defaultProps = {
  kind: `outset`,
  edge: `top`,
  color: `background`,
  isHeader: false,
}

export default Border
